<div class="mng-file-drop-zone" [class.mng-file-over]="hasDropZoneOver"><ng-content /></div>
